module.exports = __webpack_public_path__ + "static/media/moveable.4f6ab6c0.svg";